var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { ethers } from "ethers";
import { isEIP712Message } from "@ledgerhq/evm-tools/message/EIP712/index";
export const prepareMessageToSign = ({ message }) => {
    const parsedMessage = (() => {
        try {
            return JSON.parse(message);
        }
        catch (error) {
            return message;
        }
    })();
    if (isEIP712Message(parsedMessage)) {
        // With the ethers lib, EIP712Domain type should be removed otherwise
        // you'll end up with a "ambiguous primary types" error
        const _a = parsedMessage.types, { EIP712Domain } = _a, otherTypes = __rest(_a, ["EIP712Domain"]);
        return {
            standard: "EIP712",
            message: parsedMessage,
            domainHash: ethers.utils._TypedDataEncoder.hashDomain(parsedMessage.domain),
            hashStruct: ethers.utils._TypedDataEncoder.hashStruct(parsedMessage.primaryType, otherTypes, parsedMessage.message),
        };
    }
    return {
        standard: "EIP191",
        message,
    };
};
export const signMessage = (signerContext) => (deviceId, account, messageOpts) => __awaiter(void 0, void 0, void 0, function* () {
    if (messageOpts.standard === "EIP191") {
        const { r, s, v } = yield signerContext(deviceId, signer => {
            return signer.signPersonalMessage(account.freshAddressPath, Buffer.from(messageOpts.message).toString("hex"));
        });
        const signature = ethers.utils.joinSignature({
            r: `0x${r}`,
            s: `0x${s}`,
            v: typeof v === "string" ? parseInt(v, 16) : v,
        });
        return { rsv: { r, s, v }, signature };
    }
    if (messageOpts.standard === "EIP712") {
        const { r, s, v } = yield signerContext(deviceId, (signer) => __awaiter(void 0, void 0, void 0, function* () {
            try {
                return yield signer.signEIP712Message(account.freshAddressPath, messageOpts.message);
            }
            catch (e) {
                if (e instanceof Error && "statusText" in e && e.statusText === "INS_NOT_SUPPORTED") {
                    return yield signer.signEIP712HashedMessage(account.freshAddressPath, messageOpts.domainHash, messageOpts.hashStruct);
                }
                throw e;
            }
        }));
        const signature = ethers.utils.joinSignature({
            r: `0x${r}`,
            s: `0x${s}`,
            v: typeof v === "string" ? parseInt(v, 16) : v,
        });
        return { rsv: { r, s, v }, signature };
    }
    throw new Error("Unsupported message standard");
});
//# sourceMappingURL=hw-signMessage.js.map